import { createElement as _createElement } from "@emotion/react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { RfpProfessionalQuestionListItem } from '@/components/modules/pages/rfp/professional/List/RfpProfessionalQuestionList/RfpProfessionalQuestionListItem';
import { RfpProfessionalQuestionListNoData } from '@/components/modules/pages/rfp/professional/List/RfpProfessionalQuestionList/RfpProfessionalQuestionListNoData';
export const RfpProfessionalQuestionList = (props) => {
    const { className = '', items } = props;
    // 0件表示
    if (items.length === 0) {
        return (_jsx("div", Object.assign({ className: clsx('py-28', className) }, { children: _jsx(RfpProfessionalQuestionListNoData, {}) })));
    }
    // 通常表示
    return (_jsx("div", Object.assign({ className: className }, { children: items.map((item, i) => (_createElement(RfpProfessionalQuestionListItem, Object.assign({}, item, { className: 'border-b border-t-0 border-x-0 border-solid border-b-light last:border-b-0', key: item.id, questionNum: i + 1 })))) })));
};
